const APPROVED = 'APPROVED';
const SCRIPT_ID = 'nuveiScript';
const SCRIPT_URL = 'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js';

export { APPROVED, SCRIPT_ID, SCRIPT_URL };
